import { Reconciliation } from '../../../../types/finance';

export interface ReconciliationStatementRow {
  label: string;
  hint?: string;
  paisa: number;
  kind?: 'total';
}

/** The reconciliation statement — from the bank's balance to the books' — as the screen and the PDF both set it out. */
export const reconciliationStatement = (rec: Reconciliation, formatDate: (iso: string) => string): ReconciliationStatementRow[] => {
  const s = rec.summary;
  const on = formatDate(rec.statementDate);
  return [
    { label: `Balance per bank statement at ${on}`, paisa: s.statementBalancePaisa },
    { label: 'Add: deposits in transit', hint: 'In the books, not yet on the statement', paisa: s.depositsInTransitPaisa },
    { label: 'Less: unpresented payments', hint: 'Paid in the books, not yet through the bank', paisa: -s.unpresentedPaymentsPaisa },
    { label: `Balance per books at ${on}`, paisa: s.bookBalancePaisa, kind: 'total' },
  ];
};
